module.exports = require("./ta-IN");